import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import {
  Quizz,
  QuizzPerguntas,
  QuizzRespostas,
} from 'src/app/modules/_models/quizz';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-quizz',
  templateUrl: './quizz.component.html',
  styleUrls: ['./quizz.component.scss'],
})
export class QuizzComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  @Input('ExibirUsuarioNaoLogado') exibirUsuarioNaoLogado;
  @Input('ExibirUsuarioLogado') exibirUsuarioLogado;
  @Input('ExibirTodos') exibirTodos;
  @Input('SomenteAtivos') somenteAtivos;
  @Input('UsuarioLogado') usuarioLogado;
  @Input('IdQuizz') idQuizz;
  @Input('Titulo') titulo;

  regItensQuizz: FieldConfig[] = [];

  quizz: [];

  resumo: string[];

  etapaAtual: number = 1;
  qtdEtapas: number = 1;
  etapas: number[] = [];

  respostasSelecionadas: QuizzRespostas[] = [];

  multiplaEscolha: boolean = false;

  constructor(private fidelidadeService: FidelidadeService) {}

  ngOnInit(): void {
    this.regItensQuizz = [];
    this.respostasSelecionadas = [];

    if (this.idQuizz > 0) {
      this.fidelidadeService.obterQuizzPorId(this.idQuizz).subscribe(
        (quizz) => {
          this.quizz = quizz;
          this.processarSucessoQuizzPorId(this.quizz);
        },
        (falha) => {
          this.processarFalhaQuizz(falha);
        }
      );
    } else {
      this.fidelidadeService
        .obterQuizzPorTipoVisualizacao(
          this.exibirUsuarioLogado,
          this.exibirUsuarioNaoLogado,
          this.exibirTodos,
          this.somenteAtivos
        )
        .subscribe(
          (quizz) => {
            this.quizz = quizz;
            this.processarSucessoQuizz(this.quizz);
          },
          (falha) => {
            this.processarFalhaQuizz(falha);
          }
        );
    }
  }

  processarSucessoQuizz(quizz) {
    this.etapaAtual = 1;
    this.regItensQuizz = [];
    this.respostasSelecionadas = [];
    if (quizz != undefined && quizz.length > 0) {
      for (let index = 0; index < quizz.length; index++) {
        this.fidelidadeService
          .obterQuizzPerguntasPorIdQuizz(quizz[index].id)
          .subscribe(
            (quizzPerguntas) => {
              var quizzResponse: Quizz = new Quizz();

              quizzResponse.Id = quizz[index].id;
              quizzResponse.DataInicio = quizz[index].dataInicio;
              quizzResponse.DataFim = quizz[index].dataFim;
              quizzResponse.Descricao = quizz[index].descricao;
              quizzResponse.Resumo = quizz[index].resumo.split(';')[0];
              quizzResponse.ExibirUsuarioLogado =
                quizz[index].exibirUsuarioLogado;
              quizzResponse.ExibirUsuarioNaoLogado =
                quizz[index].exibirUsuarioNaoLogado;
              quizzResponse.ExibirTodos = quizz[index].exibirTodos;

              this.resumo = quizz[index].resumo.split(';');
              quizzResponse.Perguntas = [];

              if (
                quizzPerguntas != undefined &&
                quizzPerguntas != null &&
                quizzPerguntas.length > 0
              ) {
                for (
                  let indexPerguntas = 0;
                  indexPerguntas < quizzPerguntas.length;
                  indexPerguntas++
                ) {
                  var quizzPerguntaResponse: QuizzPerguntas =
                    new QuizzPerguntas();

                  quizzPerguntaResponse.Id = quizzPerguntas[indexPerguntas].id;
                  quizzPerguntaResponse.Descricao =
                    quizzPerguntas[indexPerguntas].descricao;
                  quizzPerguntaResponse.DataCadastro =
                    quizzPerguntas[indexPerguntas].dataCadastro;
                  quizzPerguntaResponse.Etapa =
                    quizzPerguntas[indexPerguntas].etapa;
                  quizzPerguntaResponse.OrdemExibicao =
                    quizzPerguntas[indexPerguntas].ordemExibicao;
                  quizzPerguntaResponse.PesoResposta =
                    quizzPerguntas[indexPerguntas].pesoResposta;
                  quizzPerguntaResponse.Ativo =
                    quizzPerguntas[indexPerguntas].ativo;
                  quizzPerguntaResponse.IdAtributo = 
                    quizzPerguntas[indexPerguntas].idAtributo;
                  quizzPerguntaResponse.TextoLivre = 
                    quizzPerguntas[indexPerguntas].textoLivre;

                  quizzResponse.Perguntas.push(quizzPerguntaResponse);
                }

                this.qtdEtapas = Math.max.apply(
                  Math,
                  quizzResponse.Perguntas.map(function (o) {
                    return o.Etapa;
                  })
                );

                this.adicionarQuizzTela(quizzResponse);
              }
            },
            (falha) => {
              this.processarFalhaQuizz(falha);
            }
          );
      }
    }
  }

  processarSucessoQuizzPorId(quizz) {
    this.etapaAtual = 1;
    this.regItensQuizz = [];
    this.respostasSelecionadas = [];
    if (quizz != undefined) {
      this.fidelidadeService.obterQuizzPerguntasPorIdQuizz(quizz.id).subscribe(
        (quizzPerguntas) => {
          var quizzResponse: Quizz = new Quizz();

          quizzResponse.Id = quizz.id;
          quizzResponse.DataInicio = quizz.dataInicio;
          quizzResponse.DataFim = quizz.dataFim;
          quizzResponse.Descricao = quizz.descricao;
          quizzResponse.Resumo = quizz.resumo.split(';')[0];
          quizzResponse.ExibirUsuarioLogado = quizz.exibirUsuarioLogado;
          quizzResponse.ExibirUsuarioNaoLogado = quizz.exibirUsuarioNaoLogado;
          quizzResponse.ExibirTodos = quizz.exibirTodos;
          
          this.multiplaEscolha = quizz.multiplaEscolha;

          this.resumo = quizz.resumo.split(';');
          quizzResponse.Perguntas = [];

          if (
            quizzPerguntas != undefined &&
            quizzPerguntas != null &&
            quizzPerguntas.length > 0
          ) {
            for (
              let indexPerguntas = 0;
              indexPerguntas < quizzPerguntas.length;
              indexPerguntas++
            ) {
              var quizzPerguntaResponse: QuizzPerguntas = new QuizzPerguntas();

              quizzPerguntaResponse.Id = quizzPerguntas[indexPerguntas].id;
              quizzPerguntaResponse.Descricao =
                quizzPerguntas[indexPerguntas].descricao;
              quizzPerguntaResponse.DataCadastro =
                quizzPerguntas[indexPerguntas].dataCadastro;
              quizzPerguntaResponse.Etapa =
                quizzPerguntas[indexPerguntas].etapa;
              quizzPerguntaResponse.OrdemExibicao =
                quizzPerguntas[indexPerguntas].ordemExibicao;
              quizzPerguntaResponse.PesoResposta =
                quizzPerguntas[indexPerguntas].pesoResposta;
              quizzPerguntaResponse.Ativo =
                quizzPerguntas[indexPerguntas].ativo;
              quizzPerguntaResponse.IdAtributo =
                quizzPerguntas[indexPerguntas].idAtributo;
              quizzPerguntaResponse.TextoLivre =
                quizzPerguntas[indexPerguntas].textoLivre;

              quizzResponse.Perguntas.push(quizzPerguntaResponse);
            }

            this.qtdEtapas = Math.max.apply(
              Math,
              quizzResponse.Perguntas.map(function (o) {
                return o.Etapa;
              })
            );

            this.adicionarQuizzTela(quizzResponse);
          }
        },
        (falha) => {
          this.processarFalhaQuizz(falha);
        }
      );
    }
  }

  adicionarQuizzTela(quizz: Quizz) {
    this.regItensQuizz.push(
      {
        type: 'label',
        label: 'Questão ' + this.etapaAtual,
        name: 'lblQuestao',
        styleDivPrincipal(): object {
          return {};
        },
        style(): object {
          return {
            width: '113px',
            height: '24px',
            left: '9.05%',
            right: '55.2%',
            top: '126px',
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '24px',
            'line-height': '24px',
            color: '#ff5c3e',
            'margin-top': '20px',
          };
        },
      },
      {
        type: 'label',
        label: quizz.Resumo,
        name: 'lblResumo',
        styleDivPrincipal(): object {
          return {};
        },
        style(): object {
          return {
            width: '100%',
            left: '80px',
            top: '174px',
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '16px',
            'line-height': '22px',
            color: '#000000',
            'margin-top': '10px',
          };
        },
      },
      {
        type: 'label',
        label: !this.multiplaEscolha ? 'Escolha uma opção' : 'Escolha uma ou mais opções',
        name: 'lblEscolhaUmaOpcao',
        styleDivPrincipal(): object {
          return {};
        },
        style(): object {
          return {
            width: '94px',
            height: '11px',
            left: '80px',
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '600',
            'font-size': '10px',
            'line-height': '11px',
            color: '#979797',
            'margin-top': '1px',
          };
        },
      }
    );

    let optionsArr = new Map<number, Map<number, any>>();

    quizz.Perguntas = quizz.Perguntas.sort((a, b) => (a.TextoLivre < b.TextoLivre ? -1 : 1));

    for (let index = 0; index < quizz.Perguntas.length; index++) {

      var qtdPerguntasEtapa = quizz.Perguntas.filter(
        (pergunta) => pergunta.Etapa === quizz.Perguntas[index].Etapa
      ).length;

      var opcaoUnica = qtdPerguntasEtapa < 2;

    var objetoQuizzPergunta = {
      id: quizz.Perguntas[index].Id,
      descricao: quizz.Perguntas[index].TextoLivre ? !opcaoUnica ? 'Outro' : 'Digite sua resposta abaixo' : quizz.Perguntas[index].Descricao,
      textoLivre: quizz.Perguntas[index].TextoLivre,
      valor: '',
      opcaoUnica: opcaoUnica,
      checked: quizz.Perguntas[index].TextoLivre ? !opcaoUnica ? false : true : false
    }
  
    this.regItensQuizz[2].visible = opcaoUnica ? false : true;

    if(opcaoUnica)
      document.documentElement.style.setProperty('--opacity', '0');
    else
      document.documentElement.style.setProperty('--opacity', '1');

      if (optionsArr.has(quizz.Perguntas[index].Etapa)) {
        optionsArr
          .get(quizz.Perguntas[index].Etapa)
          .set(quizz.Perguntas[index].Id, objetoQuizzPergunta);
      } else {
        optionsArr.set(quizz.Perguntas[index].Etapa, new Map<number, any>());
        optionsArr
          .get(quizz.Perguntas[index].Etapa)
          .set(quizz.Perguntas[index].Id, objetoQuizzPergunta);
      }
    }

    optionsArr.forEach((value: Map<number, any>, etapa: number) => {
      var arrDescricoes = [];
      var arrValues = [];
      optionsArr.get(etapa).forEach((value: any, key: number) => {
        arrValues.push(key + ';' + etapa);
        arrDescricoes.push({ value: value });
      });

      this.regItensQuizz.push({
        type: 'checkboxCustom',
        multiOptions: arrDescricoes,
        visible: etapa == this.etapaAtual,
        value: arrValues,
        change: (event) => {
          for (let index = 0; index < arrDescricoes.length; index++) {
            var objeto = event.source ? event.source._elementRef.nativeElement.innerText.trim() : event.target.id.trim();
            if (
              arrDescricoes[index].value.descricao == objeto
            ) {
              var arrSelecao = arrValues[index].split(';');
              this.selecionarCheckbox(
                arrSelecao[0],
                arrSelecao[1],
                event.checked ? event.checked : arrDescricoes[index].value.checked,
                arrDescricoes[index].value.valor,
                arrDescricoes[index].value.textoLivre
              );
            }
          }
        },
        styleDivPrincipal(): object {
          return {
            'text-align': '-webkit-center',
            'margin-top': '10px',
          };
        },
        style(): object {
          return {
            left: '7.32%',
            right: '53.18%',
            top: '36%',
            bottom: '36%',
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '500',
            'font-size': '13px',
            'line-height': '13px',
            color: '#5E5E5E',
            float: 'left',
            'text-align': 'left',
            width: '100%',
          };
        },
      });
    });
  }

  mostrarBotoesPorEtapa() {
    var etapaAtual = this.etapaAtual;
    var resumo = this.resumo[this.etapaAtual - 1];

    this.regItensQuizz.map(function (x) {
      if (x.type == 'label') {
        if (x.name == 'lblResumo') {
          x.label = resumo;
        }

        if (x.name == 'lblQuestao') {
          x.label = 'Questão ' + etapaAtual;
        }
      } else if (x.type == 'checkboxCustom') {
        x.visible = false;

        for (let indexValue = 0; indexValue < x.value.length; indexValue++) {
          var valor = x.value[indexValue].split(';');

          if (valor[1] == etapaAtual)
          {
            var elems = document.getElementsByTagName('label');

            elems[3].style.display = x.multiOptions[0].value.opcaoUnica ? "none" : "block";

            if(x.multiOptions[0].value.opcaoUnica)
            {
              x.multiOptions[0].value.checked = true;
              document.documentElement.style.setProperty('--opacity', '0');
            }
            else
              document.documentElement.style.setProperty('--opacity', '1');
            
            x.visible = true;
          }
        }
      }
    });

    const etapas: number[] = [];

    let i = 1;
    while (i <= this.qtdEtapas) {
      etapas.push(i);
      i += 1;
    }

    this.etapas = etapas;
  }

  selecionarCheckbox(idPerguntaSelecionada, etapa, checado, valor, textoLivre) {
    if (checado) {
      var perguntaNaoExisteNoArray = !this.respostasSelecionadas.find(
        (idpergunta) => idpergunta.IdQuizzPergunta == idPerguntaSelecionada
      );

      if (perguntaNaoExisteNoArray) {
        var quizzResposta: QuizzRespostas = new QuizzRespostas();
        quizzResposta.IdQuizzPergunta = idPerguntaSelecionada;
        quizzResposta.Etapa = etapa;
        quizzResposta.Valor = valor;
        quizzResposta.TextoLivre = textoLivre;
        this.respostasSelecionadas.push(quizzResposta);
      }
      else
      {
          var perguntaSelecionada = this.respostasSelecionadas.find(
            (idpergunta) => idpergunta.IdQuizzPergunta == idPerguntaSelecionada
          );

          perguntaSelecionada.Valor = valor;
      }
    } else {
      let indexArray = this.respostasSelecionadas.findIndex(
        callback,
        idPerguntaSelecionada
      );

      if (indexArray != -1) {
        this.respostasSelecionadas.splice(indexArray, 1);
      }
    }

    if (checado) {
      if (!this.multiplaEscolha) {
        for (let index = 0; index < this.regItensQuizz.length; index++) {
          if (this.regItensQuizz[index].type == 'checkboxCustom') {
            for (
              let indexValue = 0;
              indexValue < this.regItensQuizz[index].value.length;
              indexValue++
            ) {
              var valor =
                this.regItensQuizz[index].value[indexValue].split(';');

              if (
                valor[0] != idPerguntaSelecionada &&
                valor[1].toString() == this.etapaAtual.toString()
              ) {
                this.regItensQuizz[index].multiOptions[indexValue].value.checked = false;

                let indexArray = this.respostasSelecionadas.findIndex(
                  callback,
                  valor[0]
                );
          
                if (indexArray != -1) {
                  this.respostasSelecionadas.splice(indexArray, 1);
                }
              }
            }
          }
        }
      }
    }
  }

  enviarQuizz() {
    var existePerguntaNaoRespondida = false;
    let i = 1;
    while (i <= this.qtdEtapas) {
      var perguntaNaoExisteNoArray = !this.respostasSelecionadas.find(
        (idpergunta) => idpergunta.Etapa == i
      );

      if (perguntaNaoExisteNoArray) {
        existePerguntaNaoRespondida = true;
      }

      for (let index = 0; index < this.respostasSelecionadas.length; index++) {
        if(this.respostasSelecionadas[index].TextoLivre)
          if(this.respostasSelecionadas[index].Valor == '')
            existePerguntaNaoRespondida = true;
      }

      if (i == this.qtdEtapas) {
        if (!existePerguntaNaoRespondida) {
          if (this.usuarioLogado) {
            this.fidelidadeService
              .cadastrarQuizzRespostasPorUsuario(this.respostasSelecionadas)
              .subscribe(
                (response) => {
                  this.etapaAtual = 99;

                  this.regItensQuizz = [];

                  this.regItensQuizz.push(
                    {
                      type: 'image',
                      src: 'assets/images/others/quizz_envio_sucesso.gif',
                      style: () => {
                        return {
                          width: '100%',
                          height: '200px',
                          'object-fit': 'none',
                          'margin-top': '50px',
                          'margin-bottom': '30px',
                        };
                      },
                    },
                    {
                      type: 'label',
                      label: this.titulo + ' foi finalizado!',
                      styleDivPrincipal(): object {
                        return {
                          'text-align': '-webkit-center',
                        };
                      },
                      style(): object {
                        return {
                          width: '100%',
                          height: '30px',
                          left: '69px',
                          top: '334px',
                          'font-weight': 'bold',
                          'font-size': '24px',
                          'line-height': '30px',
                          'text-align': 'center',
                          color: '#000000',
                        };
                      },
                    },
                    {
                      type: 'label',
                      label: response.resultado,
                      styleDivPrincipal(): object {
                        return {
                          'text-align': '-webkit-center',
                        };
                      },
                      style(): object {
                        return {
                          width: '577px',
                          height: '40px',
                          left: '153px',
                          top: '376px',
                          'font-family': 'Sagona',
                          'font-style': 'normal',
                          'font-weight': '400',
                          'font-size': '16px',
                          'line-height': '20px',
                          'text-align': 'center',
                          color: '#000000',
                        };
                      },
                    }
                  );
                },
                (falha) => {
                  Swal.fire({
                    title: 'Ops',
                    text: 'Não foi possível enviar o quizz no momento. Por favor, tente mais tarde.',
                    icon: 'error',
                    confirmButtonColor: '#2d1708',
                    confirmButtonText: 'Ok',
                  }).then(function () {
                    return;
                  });
                }
              );
          } else {
            this.fidelidadeService
              .cadastrarQuizzRespostas(this.respostasSelecionadas)
              .subscribe(
                (response) => {
                  this.etapaAtual = 99;
                  this.regItensQuizz = [];

                  this.regItensQuizz.push(
                    {
                      type: 'image',
                      src: 'assets/images/others/quizz_envio_sucesso.gif',
                      style: () => {
                        return {
                          width: '100%',
                          height: '200px',
                          'object-fit': 'contain',
                          'margin-top': '50px',
                          'margin-bottom': '30px',
                        };
                      },
                    },
                    {
                      type: 'label',
                      label: this.titulo + ' foi finalizado!',
                      styleDivPrincipal(): object {
                        return {
                          'text-align': '-webkit-center',
                        };
                      },
                      style(): object {
                        return {
                          width: '100%',
                          height: '30px',
                          left: '69px',
                          top: '334px',
                          'font-family': 'Sagona',
                          'font-style': 'normal',
                          'font-weight': '600',
                          'font-size': '24px',
                          'line-height': '30px',
                          'text-align': 'center',
                          color: '#000000',
                        };
                      },
                    },
                    {
                      type: 'label',
                      label: response.resultado,
                      styleDivPrincipal(): object {
                        return {
                          'text-align': '-webkit-center',
                        };
                      },
                      style(): object {
                        return {
                          width: '100%',
                          height: '40px',
                          left: '153px',
                          top: '376px',
                          'font-family': 'Sagona',
                          'font-style': 'normal',
                          'font-weight': '400',
                          'font-size': '16px',
                          'line-height': '20px',
                          'text-align': 'center',
                          color: '#000000',
                        };
                      },
                    },
                    {
                      type: 'button',
                      label: 'Refazer',
                      styleDivPrincipal(): object {
                        return {
                          'text-align': '-webkit-center',
                          'margin-top': '15px',
                        };
                      },
                      style(): object {
                        return {
                          width: '230px',
                          display: 'block',
                          margin: 'auto',
                          'background-color':
                            'var(--button-background-secondary-color)',
                          color: 'var(--button-text-secondary-color)',
                        };
                      },
                      onClick: () => this.processarSucessoQuizz(this.quizz),
                    }
                  );
                },
                (falha) => {
                  Swal.fire({
                    title: 'Ops',
                    text: 'Não foi possível enviar o quizz no momento. Por favor, tente mais tarde.',
                    icon: 'error',
                    confirmButtonColor: '#2d1708',
                    confirmButtonText: 'Ok',
                  }).then(function () {
                    return;
                  });
                }
              );
          }
        } else {
          Swal.fire({
            title: 'Ops',
            text: 'Existe perguntas sem nenhuma opção escolhida ou não respondida, por favor, verificar!',
            icon: 'error',
            confirmButtonColor: '#2d1708',
            confirmButtonText: 'Ok',
          }).then(function () {
            return;
          });
        }
      }

      i += 1;
    }
  }

  processarFalhaQuizz(falha) {}

  public proximaEtapa(): void {
    this.etapaAtual = this.etapaAtual + 1;
    this.mostrarBotoesPorEtapa();
  }

  public etapaAnterior(): void {
    this.etapaAtual = this.etapaAtual - 1;
    this.mostrarBotoesPorEtapa();
  }

  public irParaEtapa(etapa: number): void {
    this.etapaAtual = etapa;
    this.mostrarBotoesPorEtapa();
  }
}

function callback(quizzResposta: QuizzRespostas) {
  if (quizzResposta.IdQuizzPergunta.toString() == this) {
    return true;
  }
}
